import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';
import st from '../popovers.module.sass';

function DateFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useSearchPageTranslation();
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={['create_time__lt', 'create_time__gte']}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          control={control}
          enableTime
          id="create_time__gte"
          // @ts-expect-error некорректно типизирован DateInput
          isClearable
          label={t('filters.common.from') ?? ''}
          name="create_time__gte"
          options={START_OF_DAY}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          control={control}
          enableTime
          id="create_time__lt"
          // @ts-expect-error некорректно типизирован DateInput
          isClearable
          label={t('filters.common.to') ?? ''}
          name="create_time__lt"
          options={END_OF_DAY}
        />
      </div>
    </FilterPopover>
  );
}

const DateFilterPopoverWithRef = forwardRef(DateFilterPopover);
export { DateFilterPopoverWithRef as DateFilterPopover };
